<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-flower-tulip" icon-small title="لیست درخواست ها" color="accent">
			<template #topActions>
				<div class="d-flex">
					<export-excel :items="filteredItems" :headers="headers" :fileName="excelFileName">
					</export-excel>
					<v-btn outlined small color="secondary" fab @click="print" size="small" class="mr-1">
						<v-icon>
							mdi-printer
						</v-icon>
					</v-btn>
					<v-menu offset-y>
						<template v-slot:activator="{ on, attrs }">
							<v-btn color="primary" class="mr-1" outlined dark v-bind="attrs" v-on="on" :loading="changeStateLoading">
								تغییر وضعیت گروهی
							</v-btn>
						</template>
						<v-list>
							<v-list-item v-for="status in statuses" :key="status.id" style="cursor: pointer;">
								<v-list-item-title @click="changeStatusBulk(status.id)">به {{ status.title }}</v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>
					<v-menu offset-y>
						<template v-slot:activator="{ on, attrs }">
							<v-btn color="primary" class="mr-1" outlined dark v-bind="attrs" v-on="on" :loading="changeStateLoading">
								تغییر وضعیت گروهی نماینده
							</v-btn>
						</template>
						<v-list>
							<v-list-item v-for="status in agentStatuses" :key="status.id" style="cursor: pointer;">
								<v-list-item-title @click="changeAgentStatusBulk(status.id)">به {{ status.title }}</v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>
				</div>
			</template>
			<div class="pa-5 pt-0">
				<v-row>
					<v-col cols="12" md="12" class="d-flex align-center justify-center">
						<date-navigator v-model="dateRange" :options="{ rangeMode: true }">
							<div class="text-center">
								<v-btn color="primary" dark small class="mx-1" @click="loadData" :loading="loading">
									دریافت اطلاعات
								</v-btn>
							</div>
						</date-navigator>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" v-if="filterStatuses.length">
						<span class="ml-2">فیلتر وضعیت:</span>
						<v-btn-toggle v-model="statusFilter" dense tile outlined color="purple" class="mr-2 flex-wrap">
							<v-btn v-for="status in filterStatuses" :key="status" :value="status" small>
								{{ status }}
								<v-badge color="blue" :content="status === 'همه' ? items.length : items.filter(x => x.str_Status == status).length || '0'" inline>
								</v-badge>
							</v-btn>
						</v-btn-toggle>
					</v-col>
					<v-col cols="12" v-if="loanTypes.length">
						<span class="ml-2">فیلتر نوع وام:</span>
						<v-btn-toggle v-model="loanTypeFilter" dense tile outlined color="purple" class="mr-2 flex-wrap">
							<v-btn v-for="loanType in loanTypes" :key="loanType.id" :value="loanType.id" small>
								{{ loanType.title }}
								<v-badge color="blue" :content="loanType.id === 'همه' ? items.length : items.filter(x => x.loanModel.id == loanType.id).length || '0'" inline>
								</v-badge>
							</v-btn>
						</v-btn-toggle>
					</v-col>
					<v-col cols="12" md="6">
						<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
					</v-col>
					<v-col cols="12">
						<div>
							<v-checkbox color="secondary" v-model="selectAllToggler" label="انتخاب همه" @change="toggleSelectAll" />
						</div>
						<v-data-table :height="dataTableFixedHeight - 100" fixed-header :loading="loading" :headers="headers" :items="filteredItems" :footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" :search="search" class="elevation-1">
							<template v-slot:item="row">
								<tr>
									<td>
										<v-checkbox color="secondary" v-model="row.item.ch" @change="(val) => updateSelectedItems(val, row.item)" />
									</td>
									<td>
										<div class="info--text" style="cursor:pointer" @click="edit(row.item)">
											<span class="text-small info--grey">شماره درخواست:</span> {{ row.item.code }}
										</div>
										<div class="">
											<small class="text-small info--grey">مبلغ: {{ row.item.amount.toString().toPriceFormat() }}</small>
										</div>
										<div class="">
											<small class="text-small info--grey">تاریخ: &lrm;{{ `${row.item.requestDate_Persian.date} ${row.item.requestDate_Persian.time}` }}</small>
										</div>
										<div><small>{{ row.item.loanModel.title }}</small></div>
									</td>
									<td>
										<div @click="manageLoans(row.item.memberModel)" style="cursor:pointer">
											<div>{{ row.item.memberModel.fullName }}</div>
											<div>
												<small class="">کد ملی: </small>
												<small class="grey--text">{{ row.item.memberModel.nationalCode }}</small>
											</div>
										</div>
									</td>
									<td class="text-center">
										<small>{{ row.item.str_Status }}</small>
									</td>
									<td>
										<small @click="editAgent({ id: row.item.agentModel.id })" style="cursor:pointer">
											{{ row.item.agentModel ? 'ن:' + row.item.agentModel.businessName : '' }}
										</small>
										<small>
											{{ row.item.memberModel && row.item.memberModel.marketerName ? 'ب:' + row.item.memberModel.marketerName : '' }}
										</small>
									</td>
									<td class="text-center">
										<small>{{ row.item.agentModel ? row.item.str_AgentStatus : '' }}</small>
									</td>
									<td class="text-center" v-if="checkActivePart('sponsor')">
										<div><small>{{ row.item.sponsorModel ? row.item.sponsorModel.businessName : '' }}</small></div>
										<div class="grey--text"><small>وضعیت: {{sponsorStatuses.findIndex(x => x.id === row.item.userLoanSponsorStatus) > -1 ? sponsorStatuses.find(x => x.id === row.item.userLoanSponsorStatus).title : row.item.sponsorModel ? 'نامعلوم' : ''}}</small></div>

									</td>
									<td>
										<small>{{ row.item.adminDescriptionPrivate || "-" }}</small>
									</td>
									<td class="text-center">
										<v-btn class="mx-1" fab dark small color="secondary" @click="edit(row.item)">
											<v-icon dark>
												mdi-square-edit-outline
											</v-icon>
										</v-btn>
										<v-btn class="mx-1" fab dark small color="pink" @click="remove(row.item)">
											<v-icon dark>
												mdi-trash-can-outline
											</v-icon>
										</v-btn>
									</td>
								</tr>
							</template>
						</v-data-table>
					</v-col>
				</v-row>
			</div>
			<v-dialog v-model="dialog" scrollable persistent max-width="1100px">
				<modify-request ref="modifyRequest" v-if="dialog" :data="selectedRequest" @callbck="callbck" @close="dialog = false" />
			</v-dialog>
		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
		<div id="printHtml" style="display: none;">
			<h2 style="margin-bottom: 10px;text-align: center;">لیست درخواست های انتخاب شده</h2>
			<table style="direction: rtl;width: 100%;">
				<thead>
					<tr style="border-bottom: 2px solid #ddd;background-color: #ddd;">
						<th style="text-align: center; padding: 5px;font-weight: bold;font-family: tahoma;border-bottom: 2px solid #ccc;">
							شماره درخواست</th>
						<th style="text-align: center; padding: 5px;font-weight: bold;font-family: tahoma;border-bottom: 2px solid #ccc;">
							نام مشتری</th>
						<th style="text-align: center; padding: 5px;font-weight: bold;font-family: tahoma;border-bottom: 2px solid #ccc;">
							تاریخ ثبت درخواست</th>
						<th style="text-align: center; padding: 5px;font-weight: bold;font-family: tahoma;border-bottom: 2px solid #ccc;">
							مشخصات وام</th>
						<th style="text-align: center; padding: 5px;font-weight: bold;font-family: tahoma;border-bottom: 2px solid #ccc;">
							مبلغ درخواستی</th>
						<th style="text-align: center; padding: 5px;font-weight: bold;font-family: tahoma;border-bottom: 2px solid #ccc;">
							نام نماینده</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in selectedItems" :key="item.id" style="border-bottom: 1px solid #ddd">
						<td style="text-align: center; padding: 5px;border-bottom: 1px solid #ddd;font-family: tahoma;">{{ item.code
						}}</td>
						<td style="text-align: center; padding: 5px;border-bottom: 1px solid #ddd;font-family: tahoma;">
							<div>{{ item.memberModel.fullName }}</div>
							<div class="grey--text">کد ملی: {{ item.memberModel.nationalCode }}</div>
						</td>
						<td style="text-align: center; padding: 5px;border-bottom: 1px solid #ddd;font-family: tahoma;">{{
							item.requestDate_Persian.date }}</td>
						<td style="text-align: center; padding: 5px;border-bottom: 1px solid #ddd;font-family: tahoma;">{{
							item.loanModel.title }}</td>
						<td style="text-align: center; padding: 5px;border-bottom: 1px solid #ddd;font-family: tahoma;">{{
							item.amount.toString().toPriceFormat() }}</td>
						<td style="text-align: center; padding: 5px;border-bottom: 1px solid #ddd;font-family: tahoma;">{{
							item.agentModel ? item.agentModel.businessName : '' }}</td>
					</tr>
				</tbody>
			</table>
		</div>

		<v-dialog v-model="dialogLoansManager" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">مدیریت وام</span></div>
					<v-spacer />
					<v-btn @click="dialogLoansManager = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<manage-loan ref="manageLoan" :data="{ member: selectedMember }" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogAgent" scrollable persistent max-width="700px">
			<v-card>
				<v-card-title>
					<span class="headline">مشخصات نماینده</span>
					<v-spacer />
					<v-btn @click="dialogAgent = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<ModifyAgent :data="selectedAgent" v-if="dialogAgent" @callbck="agent_callbck" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { emptyId } from '@/util/emptyId'
	import printJS from 'print-js'
	import { call, get } from 'vuex-pathify'
	import ManageLoan from '@/views/admin/ManageLoan.vue'
	import { sponsorStatuses } from '@/util/enums'

	export default {
		name: 'AdminLoanRequestsView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			ModifyAgent: () => import('@/views/admin/agent/ModifyAgent'),
			'manage-loan': ManageLoan,
			'modify-request': () => import('./ModifyLoanRequest.vue'),
		},
		data() {
			return {
				errorMessages: '',
				changeStateLoading: false,
				localData: {},
				selectedAgent: {},
				selectedRequest: {},
				selectedMember: null,
				dialog: false,
				dialogLoansManager: false,
				dialogAgent: false,
				search: '',
				selectAllToggler: false,
				dateRange: { start: new Date(new Date().setMonth(new Date().getMonth() - 1)).toJSON(), end: '' },
				headers: [
					{
						text: '',
						align: 'start',
						sortable: false,
						value: 'code',
						width: 20
					},
					{
						text: 'اطلاعات درخواست',
						align: 'start',
						sortable: true,
						value: 'code',
						width: 270
					}, {
						text: 'نام مشتری',
						align: 'start',
						sortable: true,
						value: 'memberModel.fullName',
						width: 150
					},
					{
						text: 'کد ملی',
						align: 'start d-none',
						sortable: true,
						value: 'memberModel.nationalCode',
					},
					{
						text: 'وام',
						align: 'start d-none',
						sortable: true,
						value: 'loanModel.title',
					},
					{
						text: 'مبلغ',
						align: 'center d-none',
						sortable: true,
						value: 'amount',
					},
					{
						text: 'تاریخ ثبت درخواست',
						align: 'center d-none',
						sortable: true,
						value: 'requestDate_Persian',
						excel_value: '%root%',
						excel_callback: (value) => {
							let text = value.requestDate_Persian?.date || 'نامشخص'
							return text
						}
					},
					{
						text: 'وضعیت',
						align: 'center',
						sortable: true,
						value: 'str_Status',
						width: 90
					},
					{
						text: 'نماینده/بازاریاب',
						align: 'center',
						sortable: true,
						value: 'agentModel.businessName',
					},
					{
						text: 'نماینده/بازاریاب',
						align: 'center d-none',
						sortable: true,
						value: 'memberModel.marketerName',
					},
					{
						text: 'وضعیت نماینده',
						align: 'center',
						sortable: true,
						value: 'str_AgentStatus',
					},
					{
						text: 'اسپانسر',
						align: 'center',
						sortable: true,
						value: 'sponsor',
						width: 150
					},
					{
						text: 'نظر کارشناس',
						align: 'start',
						sortable: true,
						value: 'adminDescription',
					},
					{
						text: 'موبایل',
						align: 'start d-none',
						sortable: true,
						value: 'memberModel.mobile',
					},
					{
						text: 'شهر',
						align: 'start d-none',
						sortable: true,
						value: 'memberModel.city',
					},
					{
						text: 'شماره حساب',
						align: 'start d-none',
						sortable: true,
						value: 'memberModel.bankAccounts',
						excel_value: '%root%',
						excel_callback: (value) => {
							let text = ''
							let parsed = value.memberModel.bankAccounts ? JSON.parse(value.memberModel.bankAccounts) : ''
							if (parsed) {
								text = parsed.map(x => x.accountNumber + '‌').join(',')
							}
							return text
						}
					},
					{
						text: 'عملیات ها',
						align: 'center',
						sortable: false,
						width: 150,
					},
				],
				items: [],
				filterStatuses: [],
				statusFilter: 'همه',
				loading: false,
				selectedItems: [],
				loanTypes: [],
				loanTypeFilter: 'همه',
				routeStatusFilter: '',
				sponsorStatuses: sponsorStatuses
			}
		},
		mounted() {
			this.routeStatusFilter = this.$route.params.statusFilter || ''
			// this.loadData()
			this.fetchLoanRequestStatus()
			this.prepareColumns()
		},
		computed: {
			statuses: get('loanRequestStatus/statuses'),
			agentStatuses: get('loanRequestStatus/agentStatuses'),
			excelFileName() {
				let name = 'گزارش درخواست وام ها'
				if (this.dateRange.start)
					name += ' از ' + this.dateRange.start.toString().split('T')[0]
				if (this.endDate)
					name += ' تا ' + this.dateRange.end.toString().split('T')[0]
				name += '.xls'
				return name
			},
			filteredItems() {
				if (this.statusFilter === 'همه' && !this.loanTypeFilter)
					return this.items

				let clonedItems = []
				clonedItems.push(...this.items)

				if (this.statusFilter !== 'همه')
					clonedItems = clonedItems.filter(x => x.str_Status === this.statusFilter)

				if (this.loanTypeFilter !== 'همه')
					clonedItems = clonedItems.filter(x => x.loanModel.id === this.loanTypeFilter)

				return clonedItems
			}
		},
		methods: {
			fetchLoanRequestStatus: call('loanRequestStatus/fetch'),
			prepareColumns() {
				if (!this.checkActivePart('sponsor')) {
					var i = this.headers.findIndex(x => x.value === 'sponsor')
					if (i > -1)
						this.headers.splice(i, 1)
				}
			},
			manageLoans(item) {
				this.selectedMember = { id: item.id, userName: item.userName, fullName: item.fullName, nationalCode: item.nationalCode, mobile: item.mobile }
				this.dialogLoansManager = true
				this.$nextTick(() => {
					this.$refs.manageLoan.loadData()
				})
			},
			updateSelectedItems(state, row) {
				if (!row)
					return
				const index = this.selectedItems.findIndex(x => x.id === row.id)
				if (state) {
					if (index === -1)
						this.selectedItems.push(row)
				} else {
					if (index !== -1)
						this.selectedItems.splice(index, 1)
				}
			},
			loadData() {
				this.loading = true
				api.get('admin/userLoanRequest/list?start=' + this.dateRange.start + '&end=' + this.dateRange.end, null)
					.then(response => {
						this.items = response
						this.selectAllToggler = false
						this.filterStatuses = [...new Set(response.map(x => x.str_Status))]
						if (this.filterStatuses.length)
							this.filterStatuses.push('همه')
						if (this.routeStatusFilter)
							this.statusFilter = this.routeStatusFilter
						this.loanTypes = Object.values(
							response.reduce((acc, obj) => ({ ...acc, [obj.loanModel.id]: obj.loanModel }), {})
						)
						if (this.loanTypes.length) {
							this.loanTypes.push({ id: 'همه', title: 'همه' })
						}
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.loading = false
					})
			},
			add() {
				this.dialog = true
				this.selectedRequest = { id: emptyId }
			},
			edit(item) {
				this.dialog = true
				this.selectedRequest = item
			},
			callbck(result) {
				// this.dialog = false
				if (result) {
					this.loadData()
				}
			},
			async remove(item) {
				if (!item) {
					return
				}

				if (
					await this.$refs.confirm.open(
						'توجه',
						'آیا از حذف این آیتم مطمئن هستید؟',
					)
				) {
					api
						.post('admin/userLoanRequest/delete/' + item.id)
						.then(response => {
							toast.success('اطلاعات با موفقیت حذف شد.')
							this.loadData()
						})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			print() {
				printJS({
					printable: 'printHtml',
					type: 'html',
					scanStyles: true, // If true inline styles will be removed
					targetStyles: ['*'],
					style: [`#printHtml {display:block!important;}`]
				})
			},
			async changeStatusBulk(newStatus) {
				if (this.selectedItems.length === 0) {
					toast.error('هیچ آیتمی انتخاب نشده است، ابتدا آیتم های مورد نظر را انتخاب کنید')
					return
				}

				if (await this.$refs.confirm.open(
					'توجه',
					`آیا از تغییر وضعیت ${this.selectedItems.length} آیتم مطمئن هستید؟`,
				)) {
					this.changeStateLoading = true
					api.post('admin/UserLoanRequest/ChangeStatusBulk/', { ids: this.selectedItems.map(x => x.id), statusId: newStatus })
						.then(
							response => {
								toast.success('تغییر وضعیت با موفقیت انجام شد.')
								this.loadData()
							})
						.catch(err => {
							toast.error(err.message)
						}).finally(() => this.changeStateLoading = false)
				}
			},
			async changeAgentStatusBulk(newStatus) {
				if (this.selectedItems.length === 0) {
					toast.error('هیچ آیتمی انتخاب نشده است، ابتدا آیتم های مورد نظر را انتخاب کنید')
					return
				}

				if (await this.$refs.confirm.open(
					'توجه',
					`آیا از تغییر وضعیت ${this.selectedItems.length} آیتم مطمئن هستید؟`,
				)) {
					this.changeStateLoading = true
					api.post('admin/UserLoanRequest/ChangeAgentStatusBulk/', { ids: this.selectedItems.map(x => x.id), agentStatusId: newStatus })
						.then(
							response => {
								toast.success('تغییر وضعیت با موفقیت انجام شد.')
								this.loadData()
							})
						.catch(err => {
							toast.error(err.message)
						}).finally(() => this.changeStateLoading = false)
				}
			},
			toggleSelectAll() {
				this.filteredItems.forEach(x => x.ch = this.selectAllToggler)
				if (!this.selectAllToggler)
					this.selectedItems = []
				else
					this.selectedItems = [...this.filteredItems]
			},
			editAgent(agent) {
				if (!agent?.id)
					return
				this.selectedAgent = agent
				this.dialogAgent = true
			},
			agent_callbck(result) {
				this.dialogAgent = false
			},
		},
	}
</script>
<style></style>
